import { Result, Username } from '@standardnotes/domain-core';
export class GetAuthenticatorAuthenticationOptions {
    constructor(authenticatorClient) {
        this.authenticatorClient = authenticatorClient;
    }
    async execute(dto) {
        const usernameOrError = Username.create(dto.username);
        if (usernameOrError.isFailed()) {
            return Result.fail(`Could not generate authenticator authentication options: ${usernameOrError.getError()}`);
        }
        const username = usernameOrError.getValue();
        const authenticationOptions = await this.authenticatorClient.generateAuthenticationOptions(username);
        if (authenticationOptions === null) {
            return Result.fail('Could not generate authenticator authentication options');
        }
        return Result.ok(authenticationOptions);
    }
}
